/**
 * Which file a bill validation report email carries: the PDF or the HTML copy,
 * never both. Chosen in Super Admin → System Configuration and stored as the
 * `bv_report_attachment` sys_config row, `{ "format": "pdf" | "html" }`.
 *
 * One file only because the report is uploaded from the browser and Vercel
 * refuses a request body over 4.5 MB: the PDF alone is ~2.2 MB, and PDF + HTML
 * together failed every send with a 413 on 2026-10-14.
 *
 * Shared by the send dialogs (which file to capture), the send route (which file
 * to require and attach) and the Super Admin editor, so the three read the
 * setting the same way.
 */

export type ReportAttachmentFormat = 'pdf' | 'html';

export const REPORT_ATTACHMENT_CONFIG = 'bv_report_attachment';

/** No row, or anything unrecognised, is the PDF — the attachment clients already know. */
export const DEFAULT_REPORT_ATTACHMENT: ReportAttachmentFormat = 'pdf';

export function reportAttachmentFormat(value: unknown): ReportAttachmentFormat {
  const format = (value as { format?: unknown } | null | undefined)?.format;
  return format === 'html' ? 'html' : DEFAULT_REPORT_ATTACHMENT;
}
